const getMaxMin = (arr) => arr?.reduce((acc, { y }) => {
  if (y > acc.barMax) {
    Reflect.set(acc, "barMax", y);
  }

  if (y < acc.barMin) {
    Reflect.set(acc, "barMin", y);
  }

  return acc;
}, { barMax: -Infinity, barMin: Infinity });

export default getMaxMin;
